export const ru = {
    'suggest-request-error': 'Ошибка получения списка участников',
};
